import {
  IList,
  IListElement,
  IListElementButtonCell,
  isButtonCell,
} from 'app/services/api5-service/api.interface';
import { getButtonList } from 'components/form-button/form-button.utils';
import { IFormButtonUi } from 'components/form-button/model';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { IListToolbarUi } from '../list-table/list-toolbar/model';
import { IListRowUi } from '../model';

/**
 * Get delete button metadata
 *
 * @param state
 * @param control
 * @param elements
 */
function getDeleteButton(
  state: ISPFormState,
  control: IList,
  elements: IListElement[],
): IFormButtonUi | undefined {
  const buttonColumnsNames = control.col
    .filter(column => column.$type === 'button')
    .map(column => column.$name);

  for (const element of elements) {
    const buttons = buttonColumnsNames
      .map(name => element[name])
      .filter(cell => isButtonCell(cell))
      .map((cell: IListElementButtonCell) =>
        DocHelper.getArrayWrapperValue(cell.button),
      )
      .flat();

    const firstDeleteButton = buttons.find(button => button.$name === 'delete');
    if (firstDeleteButton) {
      return getButtonList(
        state.docSubject.value,
        [firstDeleteButton],
        false,
      )[0];
    }
  }
}

/**
 * Map list meta to list header
 *
 * @param control - list meta
 * @param elements
 * @param rows
 * @param state
 */
export function getListToolbar(
  control: IList,
  elements: IListElement[],
  rows: IListRowUi[],
  state: ISPFormState,
): IListToolbarUi | undefined {
  if (control.$type !== 'selectable') {
    return;
  }

  return {
    showSelect: control.col.some(column => column.$type === 'select'),
    showToggle: rows.some(row =>
      // check internal lists if some of them has collapse
      row.cells.some(cell => cell.listData?.collapse),
    ),
    deleteButton: getDeleteButton(state, control, elements),
    deleteConfirmMsg: {
      header: DocHelper.getMessage(
        'msg_frontend_button_delete_confirm_title',
        state.docSubject.value,
      ),
      description: DocHelper.getMessage(
        'msg_frontend_button_delete_confirm_description',
        state.docSubject.value,
      ),
      ok: DocHelper.getMessage(
        'msg_frontend_button_delete_confirm_ok',
        state.docSubject.value,
      ),
      cancel: DocHelper.getMessage(
        'msg_frontend_button_delete_confirm_cancel',
        state.docSubject.value,
      ),
    },
    selectMsg: DocHelper.getMessage(
      'selectable_chose_all',
      state.docSubject.value,
    ),
    deleteMsg: DocHelper.getMessage(
      'selectable_delete_selected',
      state.docSubject.value,
    ),
    collapseMsg: DocHelper.getMessage(
      'selectable_hide',
      state.docSubject.value,
    ),
    expandMsg: DocHelper.getMessage('selectable_show', state.docSubject.value),
  };
}
